module.exports = __webpack_public_path__ + "assets/img/mytravel.e7627af7.png";